const colors = {
  primary: '#0091EA',
  primaryDark: '#01579B',
  secondaryGreen: '#00BFA5',
  infoMain: '#00ACC1',
  textPrimary: '#303030',
  textSecondary: 'rgba(97, 97, 97, 0.9)',
  textDisabled: 'rgba(170, 170, 170, 0.8)',
  grey100: '#F5F5F5'
};

export default colors;
